/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircleArrowDownLeft = createReactComponent(
  "circle-arrow-down-left",
  "IconCircleArrowDownLeft",
  [
    ["path", { d: "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0", key: "svg-0" }],
    ["path", { d: "M15 9l-6 6", key: "svg-1" }],
    ["path", { d: "M15 15h-6v-6", key: "svg-2" }]
  ]
);

export { IconCircleArrowDownLeft as default };
//# sourceMappingURL=IconCircleArrowDownLeft.js.map
